//@ts-nocheck
import React from "react";
import Atom from "../../atom";
import { Trn } from "../../../translations/language";

export default function LoadingWrapper(props) {
  const { children } = props;
  return (
    (
      <Atom.Div className="absoluteCentered">
        <Atom.Div className="text-center">
          <Atom.Spinner color="primary" />
        </Atom.Div>
        <Atom.Typography type="h6" className="text-center">
          {Trn({ text: "waiting" })}
        </Atom.Typography>
      </Atom.Div>
    ) || children
  );
}
